import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import axios from 'axios';

import { setLoading, showErrorModal, useApplicationState } from '../../../utilities/applicationState';
import UsageByVerticalAndVerifier from './usageByVerticalAndVerifier';
import UsageByVertical from './usageByVertical';
import ApiVolumeByTime from './apiVolumeByTime';
import { SdfBox } from '@synerg/react-components';

export default function ApiUsageView({ isAdminView = false, partnerOOID = '' }) {
	const [, dispatch] = useApplicationState();
	const [data, setData] = useState([]);
	const [timelineNumber, setTimelineNumber] = useState(0);
	const [moduleLoading, setModuleLoading] = useState(true);

	const getName = (str) => {
		let industry = '';
		try {
			[, industry] = str.match(/{name[=:]([^,]*), code[=:].*/);
			if (!industry) {
				industry = str;
			}
		} catch (e) {
			return str;
		}
		return industry;
	};

	const getApiUsageData = async (timelineNum) => {
		try {
			dispatch(setLoading(true));
			const params = {
				partnerOOID: partnerOOID,
				timeline: `${timelineNum}`,
				mode: 'json'
			};

			let { data } = await axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/datacloud/graph-data`, { params });
			data.client_industry = data.client_industry.map(item => ({ ...item, industry: getName(item.industry) }));
			setData(data.client_industry);
			setTimelineNumber(data.timeline);
			setModuleLoading(false);
			dispatch(setLoading(false));

		} catch (e) {
			if (e) {
				const errorMessage = get(e, 'response.data.message', 'Something went wrong when trying to retrieve billable API transaction history. Please try again.');
				dispatch(showErrorModal(errorMessage));
				setModuleLoading(false);
				dispatch(setLoading(false));
			}
		}
	};

	useEffect(() => {
		getApiUsageData(24);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className='usage-view-container mt-5 block max-w-full'>
			<div className='graphs-section  overflow-auto gap-5'>
				<SdfBox variant='shadowed' className='api-volume'>
					<ApiVolumeByTime data={data} loading={moduleLoading} />
				</SdfBox>
				<SdfBox variant='shadowed' className='api-usage-chart'>
					<UsageByVertical {...{ data, getApiUsageData, timelineNumber, isAdminView }} loading={moduleLoading} />
				</SdfBox>
			</div>
			<SdfBox variant='shadowed' className='api-usage-table mt-5'>
				<UsageByVerticalAndVerifier {...{ data, getApiUsageData, timelineNumber, isAdminView, partnerOOID }} loading={moduleLoading} />
			</SdfBox>
		</div>
	);
}
